
import { Button } from 'react-bootstrap';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import { Modal } from 'react-bootstrap';
import { useEffect, useState, useRef } from 'react';
import { Form } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';

import api_url from '../../config/api_url';

/*
 *
 * callback funktion til redigering / oprettelse fungerer over index, frem for id.
 * dvs hvis index på noget tidspunkt er ulig id i databasen, fucker det hele op xd
 * 
 * fix asap ty
 * 
 */


const RecipeIngredientDisplay = (props) => {

    const [edit, setEdit] = useState(false);
    const [ingredientObj, setIngredientObj] = useState(props.obj);
    const [ingredientList, setIngredientList] = useState([{id:1, name:""}]);
    const [preSelectedVal, setPreselectedVal] = useState(-1);

    const editRecipeIngredientId = (newValArr) => {

        if(newValArr.length !== 1) {
            return;
        }
        if(newValArr[0].id==props.obj.ingredient_id) {
            console.log("same");
            return;
        }
        let newObj = { ...ingredientObj };
        newObj.ingredient_id = newValArr[0].id;
        //setPreselectedVal(newValArr)
        setIngredientObj({...newObj});
    }


    const editRecipeIngredientWeight = (newVal) => {

        if(newVal==props.obj.name) {
            console.log("new val is same");
            return;
        }
        let newObj = {...ingredientObj};
        newObj.weight = newVal;

        
        setIngredientObj(newObj);
    }

    useEffect(()=>{
        props.editFunction(props.index, ingredientObj);
    }, [ingredientObj])
    
    useEffect(()=>{
        setIngredientObj(props.obj);
    }, [props.obj])


    useEffect(()=>{
        let isSubscribed = true;

        // declare the async data fetching function
        const fetchData = async () => {
          // get the data from the api
          

          const fetchUrl = api_url + "/api/ingredients";
          const data = await fetch(fetchUrl);
          const json = await data.json();

          
          let k = 0;
          for(let obj of json) {
            
            if(obj.id==props.obj.ingredient_id) {
                setPreselectedVal(k);
            }
            k++;
          }
          


          // set state with the result if `isSubscribed` is true
          if (isSubscribed) {
            setIngredientList(json);
          }
        }
      
        // call the function
        fetchData()
          // make sure to catch any error
          .catch(console.error);;
      
        // cancel any future `setData`
        return () => isSubscribed = false;
      }, [props.edit])


    const deleteRecipeIngredient = () => {
        props.deleteFunction(props.index);
    }
    

    const handleEdit = () => {
        setEdit(true);
    }

    useEffect(()=>{
    }, [preSelectedVal])

    return (
        <Row className="border mb-3">
            <Col xs={6}>
                <TypeaheadComponent changeFn={editRecipeIngredientId} options={ingredientList} selected={preSelectedVal} />
            </Col>
            <Col xs={2}>
                <WeightComponent nameVal={props.obj.weight} edit={true} handleEdit={editRecipeIngredientWeight} />
            </Col>
            <Col xs={4}>
                {/*<Button onClick={handleEdit} value="Rediger">Rediger</Button>*/}
                <Button onClick={deleteRecipeIngredient} value="Slet ingrediens">Slet </Button>
            </Col>
        </Row>
        
    );

}
/*
const RecipeIngredientDropdown = (props) => {
    const [ingredientList, setIngredientList] = useState(props.ingredientList);

    useEffect(()=>{
        setIngredientList([...props.ingredientList])
    }, [props.ingredientList]);

    if(ingredientList.length>0) {
        return <Typeahead
        onChange={(selected) => {
            console.log(selected);
        }}
        options={ingredientList.map((obj) => { obj.label = obj.name}) || []}
        />
    }

    return <p>nææ den er</p>


}
*/

const TypeaheadComponent = (props) => {
    const [selected, setSelected] = useState(props.selected)

    const [selectedOption, setSelectedOption] = useState([{name:""}]);

    const ref = useRef(null);

    useEffect(()=>{
        if(props.selected>=0) {
            setSelectedOption(props.options.slice(props.selected, props.selected+1));
        }
    },[props.selected, props.options])

    useEffect(()=>{

    }, [selectedOption])


    const onChangeFunction = (val) =>{
        setSelectedOption(val);


        props.changeFn(val)
    }

    return (
        
        <Typeahead
            id="typeahead_ingr"
            labelKey="name"
            onChange={onChangeFunction}
            selected={selectedOption}
            options={props.options}
            />
        )
    
}


const WeightComponent = (props) => {
    const [weight, setWeight] = useState(props.nameVal);
    const [edit, setEdit] = useState(props.edit)
    

    /*
    useEffect(() => {
        setWeight(props.nameVal);
        setEdit(props.edit)
    }, [props.edit, props.nameVal])
    */


    const updateRecipeIngredient = (val) => {
        console.log(val);
        props.handleEdit(val)
    }
    
    if(edit) {
        return <><input
        size={2}
        defaultValue={props.nameVal || "0"}
        placeholder="vægt (i gram)"
        //onChange={e => e.target.value = e/*setWeight(e.target.value)*/}
        onBlur={e => updateRecipeIngredient(e.target.value)}
        /><span> gram</span></>
    }

    return <p>{props.nameVal}</p>
}

export default RecipeIngredientDisplay;